/**
 * Geld (GELD) — 15 families, 2 skills
 *
 * Skills: geld_basis (6), geld_toegepast (9)
 *
 * Created as part of Fase 0 TGL Split (17 maart 2026).
 * Split from TGL.ts — GELD families only.
 *
 * familyIds normalized: GELD-* (T8 Phase 2, april 2026).
 */

import type { FamilyDefinition } from '../types'

export const GELD_FAMILIES: FamilyDefinition[] = [
  // 1. Skill: geld_basis (6 families)
  {
    familyId: 'GELD-TELLEN',
    module: 'Geld',
    skill: 'geld_basis',
    subSkill: 'geld_tellen',
    tier: 1,
    levelCode: 'B6',
    description: 'Geld tellen en herkennen',
  },
  {
    familyId: 'GELD-MAAK',
    module: 'Geld',
    skill: 'geld_basis',
    subSkill: 'geld_bedrag_maken',
    tier: 2,
    levelCode: 'B6+',
    description: 'Bedrag samenstellen',
  },
  {
    familyId: 'GELD-TERUG',
    module: 'Geld',
    skill: 'geld_basis',
    subSkill: 'geld_teruggeven',
    tier: 3,
    levelCode: 'M6',
    description: 'Wisselgeld teruggeven (aanvulmethode)',
  },
  {
    familyId: 'GELD-WISSEL',
    module: 'Geld',
    skill: 'geld_basis',
    subSkill: 'geld_wisselgeld',
    tier: 4,
    levelCode: 'M6+',
    description: 'Wisselgeld berekenen (aftrekmethode)',
  },
  {
    familyId: 'GELD-KOMMA',
    module: 'Geld',
    skill: 'geld_basis',
    subSkill: 'geld_kommagetallen',
    tier: 7,
    levelCode: 'B7',
    description: 'Euro/cent notatie rekenen',
  },
  {
    familyId: 'GELD-WISSELEN',
    module: 'Geld',
    skill: 'geld_basis',
    subSkill: 'geld_valuta',
    tier: 9,
    levelCode: 'M7',
    description: 'Valuta wisselen (basis)',
  },
  // 2. Skill: geld_toegepast (9 families)
  {
    familyId: 'GELD-BOODSCHAPPEN',
    module: 'Geld',
    skill: 'geld_toegepast',
    subSkill: 'geld_boodschappen',
    tier: 8,
    levelCode: 'B7+',
    description: 'Boodschappen doen (totaal)',
  },
  {
    familyId: 'GELD-KOOPJES',
    module: 'Geld',
    skill: 'geld_toegepast',
    subSkill: 'geld_vergelijken',
    tier: 9,
    levelCode: 'M7',
    description: 'Prijzen vergelijken',
  },
  {
    familyId: 'GELD-BUDGET',
    module: 'Geld',
    skill: 'geld_toegepast',
    subSkill: 'geld_budget',
    tier: 10,
    levelCode: 'M7+',
    description: 'Budget beheren',
  },
  {
    familyId: 'GELD-KORTING',
    module: 'Geld',
    skill: 'geld_toegepast',
    subSkill: 'geld_korting',
    tier: 10,
    levelCode: 'M7+',
    description: 'Korting berekenen',
  },
  {
    familyId: 'GELD-SPAREN',
    module: 'Geld',
    skill: 'geld_toegepast',
    subSkill: 'geld_sparen',
    tier: 10,
    levelCode: 'M7+',
    description: 'Sparen en rente (basis)',
  },
  {
    familyId: 'GELD-PRIJS-PER',
    module: 'Geld',
    skill: 'geld_toegepast',
    subSkill: 'geld_prijs_per_eenheid',
    tier: 11,
    levelCode: 'E7',
    description: 'Prijs per eenheid (kg/l/stuk)',
  },
  {
    familyId: 'GELD-RENTE-PROC',
    module: 'Geld',
    skill: 'geld_toegepast',
    subSkill: 'geld_rente_procent',
    tier: 13,
    levelCode: 'B8',
    description: 'Rente en procenten (toegepast)',
  },
  {
    familyId: 'GELD-BTW',
    module: 'Geld',
    skill: 'geld_toegepast',
    subSkill: 'geld_btw',
    tier: 15,
    levelCode: 'E8',
    description: 'BTW berekenen',
  },
  {
    familyId: 'GELD-TERUGREKENEN',
    module: 'Geld',
    skill: 'geld_toegepast',
    subSkill: 'geld_terugrekenen',
    tier: 16,
    levelCode: 'E8+',
    description: 'Originele prijs berekenen',
  },
]
